module["exports"] = [
  "გამზ.",
  "გამზირი",
  "ქ.",
  "ქუჩა",
  "ჩიხი",
  "ხეივანი"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ge/address/street_suffix.js
// module id = 3024
// module chunks = 1609